import {
    FETCH_PRODUCT_PROPERTY,
    FETCH_PRODUCT_PROPERTY_SUCCESS,
    FETCH_PRODUCT_PROPERTIES,
    FETCH_PRODUCT_PROPERTIES_SUCCESS,
    CREATE_PRODUCT_PROPERTY_SUCCESS,
    DELETE_PRODUCT_PROPERTY_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    loading: false,
    offset: 0,
    size: 0,
    total: 0,
};

export default function productProperties(state = initialState, action) {
    switch (action.type) {
        case FETCH_PRODUCT_PROPERTY:
        case FETCH_PRODUCT_PROPERTIES:
            return Object.assign(state, {
                loading: true,
            });

        case FETCH_PRODUCT_PROPERTIES_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.response.results, (value) => {
                return value.id;
            });

            return Object.assign({}, state, {
                data: Object.assign(state.data, {
                    [action.payload.productId]: convertResultsToData,
                }),
                loading: false,
                offset: action.response.offset,
                size: action.response.size,
                total: action.response.total,
            });

        case CREATE_PRODUCT_PROPERTY_SUCCESS:
        case FETCH_PRODUCT_PROPERTY_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign(state.data, {
                    [action.payload.productId]: {
                        [action.payload.propertyId]: action.response,
                    },
                }),
                loading: false,
            });

        case DELETE_PRODUCT_PROPERTY_SUCCESS:
            const deletedData = state.data;

            if (deletedData[action.payload.productId][action.payload.propertyId]) {
                delete deletedData[action.payload.productId][action.payload.propertyId];
            }

            return Object.assign({}, state, {
                data: deletedData,
                loading: false,
                total: state.total - 1,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/productPropertiesReducer.js